import _styled from '@emotion/styled/base';

var BaseTextButton = _styled("button", {
  target: "epk8kof0",
  label: "BaseTextButton"
})("border-color:transparent;background-color:transparent;border-radius:", _ref => {
  var {
    theme
  } = _ref;
  return theme.BORDER_RADIUS.small;
}, ";color:", _ref2 => {
  var {
    disabled,
    theme
  } = _ref2;
  return "".concat(disabled ? theme.COLORS.textDisabled : theme.COLORS.primary);
}, ";cursor:", _ref3 => {
  var {
    disabled
  } = _ref3;
  return disabled ? 'not-allowed' : 'pointer';
}, ";&:hover{opacity:0.8;background-color:transparent;}&:active,&:focus{outline:none;box-shadow:", _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.BOX_SHADOWS.focus;
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNxQyIsImZpbGUiOiJzdHlsZS50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmNvbnN0IEJhc2VUZXh0QnV0dG9uID0gc3R5bGVkLmJ1dHRvbiBgXG4gIGJvcmRlci1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gIGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuICBib3JkZXItcmFkaXVzOiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLkJPUkRFUl9SQURJVVMuc21hbGx9O1xuXG4gIGNvbG9yOiAkeyh7IGRpc2FibGVkLCB0aGVtZSB9KSA9PiBgJHtkaXNhYmxlZCA/IHRoZW1lLkNPTE9SUy50ZXh0RGlzYWJsZWQgOiB0aGVtZS5DT0xPUlMucHJpbWFyeX1gfTtcbiAgY3Vyc29yOiAkeyh7IGRpc2FibGVkIH0pID0+IChkaXNhYmxlZCA/ICdub3QtYWxsb3dlZCcgOiAncG9pbnRlcicpfTtcblxuICAmOmhvdmVyIHtcbiAgICBvcGFjaXR5OiAwLjg7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogdHJhbnNwYXJlbnQ7XG4gIH1cblxuICAmOmFjdGl2ZSxcbiAgJjpmb2N1cyB7XG4gICAgb3V0bGluZTogbm9uZTtcbiAgICBib3gtc2hhZG93OiAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLkJPWF9TSEFET1dTLmZvY3VzfTtcbiAgfVxuYDtcbmV4cG9ydCBkZWZhdWx0IHtcbiAgICBCYXNlVGV4dEJ1dHRvbixcbn07XG4vLyMgc291cmNlTWFwcGluZ1VSTD1zdHlsZS5qcy5tYXAiXX0= */"));

var Style = {
  BaseTextButton
};

export { Style as default };
